import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const cancelPreviewSlice = createSlice({
  name: 'cancelPreview',
  initialState,
  reducers: {
    cancelPreviewRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    cancelPreviewSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    cancelPreviewFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    cancelPreviewReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const cancelPreviewSliceAction = cancelPreviewSlice.actions;
export default cancelPreviewSlice;